module.exports = __webpack_public_path__ + "img/01040301.aadeca6b.png";